export default __webpack_public_path__ + "static/media/Shipping.f0a40785.jpg";